import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as S from './SeoPage.styles';
import SeoSearchHeader from '../SearchPage/components/ModifySearchHeader/ModifySearchHeaderUI';
import SeoPageHeader from './containers/SeoPageHeader/SeoPageHeaderUI';
import Filter from '../../containers/Filter/Filter';
import Listing from './containers/Listing/Listing';
import AlternateListing from "./containers/AlternateListing/AlternateListing";
import SeoContainer from './containers/SeoContainer/SeoContainer';
import SeoInterLinking from './containers/SeoInterLinking/SeoInterLinking';
import { pageView } from '../../config/ga';
import { lobDataSelector,commonSelector, showSEOLeadgenSelector, showLeaveIntentSelector, seoFormCouponSelector } from './redux/selector';
import RydeAssuredCardUI from "./../../../stories/components/cars/ResultsPage/RydeAssuredBanner/RydeAssuredCard/RydeAssuredCardUI";
import { rydeAssuredBannerData } from "./../../config/constants";
import { gcRouteSEOScreen, getLoadedComponent } from '../../config/omni';
import { RoutePageComp } from '../../utils/util-constants';
import { getTravellerInformation } from '../Homepage/redux/thunks';
import { travellerDetailsCalledSelector } from '../Homepage/redux/selector';
import TripAssistant from './containers/LeadGenButton/TripAssistant';
import { logEventToXDMWithPage } from 'xdmLogging/fireEventHelpers';

export default function RoutePage() {
  const showLOBComponents = useSelector(lobDataSelector);
  const commonData = useSelector(commonSelector);
  const showSEOLeadgen = useSelector(showSEOLeadgenSelector);
  const travellerDetailsCalled = useSelector(travellerDetailsCalledSelector);
  const showLeaveIntent = useSelector(showLeaveIntentSelector)
  const couponData = useSelector(seoFormCouponSelector)
  const [isPageViewCalled, setIsPageViewCalled] = useState(false);
  const is_ryde_enabled = function() {
    if(commonData && commonData.ryde_dispatch_search_id){
      return true
    }
    return false
  }()
  const dispatch = useDispatch();

  useEffect(() => {
    getLoadedComponent(RoutePageComp)
    try {
      dispatch(getTravellerInformation())
    } catch (e) {
      console.log("error", e)
    }
    
  }, []);

  useEffect(() => {
    if (travellerDetailsCalled && !isPageViewCalled) {
      setIsPageViewCalled(true)
      dispatch(pageView(gcRouteSEOScreen))
      logEventToXDMWithPage();
    }
  }, [travellerDetailsCalled, isPageViewCalled])

  const { heading, subHeading, iconName, sliderList } = rydeAssuredBannerData;
 
  return (
    <S.SeoWrapper>
      <SeoSearchHeader isSeo />
      <S.PageHeader>
        <SeoPageHeader />
      </S.PageHeader>
      <S.SeoPageWrapper>
        <S.PageRight isRoute>
          {!showLOBComponents && (
            <React.Fragment>
              {
        is_ryde_enabled && false ? (
          <>
            <RydeAssuredCardUI heading={heading} subHeading={subHeading} iconName={iconName} sliderList={sliderList} margin="0 0 1.7rem 0" /> 
          </>
        ) : null
      }
              <Listing />
              <AlternateListing />
            </React.Fragment>
          )}
          <SeoContainer />
          <SeoInterLinking />
        </S.PageRight>
        <S.PageLeft>
          {!showLOBComponents && <Filter isSeo />}
        </S.PageLeft>
      </S.SeoPageWrapper>
      <TripAssistant pageName="Seo" showIcon={showSEOLeadgen} showLeaveIntent={showLeaveIntent} coupon={couponData}/>
    </S.SeoWrapper>
  );
}